import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-openingstijden',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconOpeningstijden {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M28 20c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8m1.59 11-2.29-2.29a.99.99 0 0 1-.29-.71v-4.01c0-.55.45-1 1-1s1 .45 1 1v3.59l2 2a.996.996 0 1 1-1.41 1.41ZM18 28c0-5.52 4.48-10 10-10 .89 0 1.75.13 2.58.35l-.54-7.49A2.005 2.005 0 0 0 28.05 9h-5.13l-.02 3.87c.3.27.5.67.5 1.11 0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5c0-.44.2-.84.5-1.11V6.92a6.919 6.919 0 0 0-2-4.84c2.25.37 4 2 4 3.94v.62c0 .55.45 1 1 1s1-.45 1-1v-.62C24.9 2.7 21.75 0 17.93 0c-.7 0-1.39.09-2.04.27V.25s-.04.01-.05.02c-.6-.17-1.22-.26-1.87-.26-3.9 0-7.08 3.11-7.08 6.92L6.87 9H3.76c-1.05-.02-1.93.79-2 1.84L0 33.85A2 2 0 0 0 2 36h20.01c-2.43-1.82-4.02-4.72-4.02-8ZM9.85 15.48c-.83 0-1.5-.67-1.5-1.5 0-.44.2-.84.5-1.11l.03-5.95c0-2.21 1.51-4.06 3.58-4.68-.97 1.04-1.57 2.35-1.57 3.78v.62c0 .55.45 1 1 1s1-.45 1-1v-.62c0-1.58 1.21-3.01 2.95-3.66 1.8.72 3.05 2.47 3.05 4.56l-.02 2.06h-8l-.02 3.89c.31.27.5.67.5 1.11 0 .83-.67 1.5-1.5 1.5"/>
</svg>

    );
  }
}
